import LegalPage from "../components/LegalPage";
import { privacyPolicyContent } from "../data/legalContent";

const PrivacyPolicyPage = () => {
  return <LegalPage pageTestId="privacy-policy-page" {...privacyPolicyContent} />;
};

export default PrivacyPolicyPage;